import dayjs from 'dayjs'

// plugins
import utc from 'dayjs/plugin/utc'

export const dayjsSetup = () => {
  dayjs.extend(utc)
  // extend from other plugins here
}